import { useEffect, useState } from 'react';
import { type GameTheme, Themes } from './themes.ts';
import { GetLocalStorage, LocalStorageKeyName, SetLocalStorage } from '../util/local-storage.ts';

export function useTheme(): [GameTheme, (themeName: string) => void] {
    const initialValue = GetLocalStorage(LocalStorageKeyName.Theme);
    const initialTheme = Themes.find((t) => t.name === initialValue) || Themes[0]!;
    const [theme, setThemeInternal] = useState<GameTheme>(initialTheme);

    function setTheme(themeName: string) {
        document.body.setAttribute('data-theme', themeName);

        SetLocalStorage(LocalStorageKeyName.Theme, themeName);

        const e = new StorageEvent('storage', {
            key: LocalStorageKeyName.Theme,
            newValue: themeName
        });

        window.dispatchEvent(e);
    }

    useEffect(() => {
        function onStorageChange(event: StorageEvent) {
            if (event.key === LocalStorageKeyName.Theme) {
                const theme = Themes.find((t) => t.name === event.newValue);
                if (theme) {
                    setThemeInternal(theme);
                }
            }
        }

        window.addEventListener('storage', onStorageChange);
        setTheme(initialTheme.name);

        return () => {
            window.removeEventListener('storage', onStorageChange);
        };
    }, []);

    return [theme, setTheme];
}